import React from 'react';
import TableEnhancedContainer from '../../../TableEnhanced/TableEnhancedContainer';
import { markupMap } from './TableComponents/columnMarkupMap';

function TableAdapter(props) {
  let columnsConfig = props.settings.Configuration.columnsConfig;

  markupMap(props).forEach((markupCallbacks) => {
    if (columnsConfig.find((e) => e.type === 'markup' && e.key === markupCallbacks.key)) {
      columnsConfig.find((e) => e.type === 'markup' && e.key === markupCallbacks.key).markup =
        markupCallbacks.markup;
    }
  });

  return (
    <div>
      {props.settings.Name && props.settings.Name.charAt(0) != '_' ? (
        <h4 className="u-ml-full">{props.settings.Name}</h4>
      ) : null}
      <TableEnhancedContainer
        columns={columnsConfig}
        data={props.settings.Data || []}
        enableHideColumns={true}
        enableActionButtons={true}
        extraActionsButtons={props.settings.Configuration.extraActions}
        instrumentInfo={props.query ? props.query.SelectedInstrument || 'N/A' : 'N/A'}
        hasFooter={props.settings.Configuration.hasFooter || false}
        data-qa={`qa-table-${props.settings.Name}`}
        onClickRow={
          props.settings.Configuration.onClickRowAction
            ? (row, col) =>
                props.onReportItemEvent(
                  {
                    row: row,
                    col: col,
                    onClickConfig: props.settings.Configuration.onClickRowAction,
                  },
                  'onClickRow'
                )
            : undefined
        }
        onReportItemEvent={props.onReportItemEvent}
        query={props.query}
      />
    </div>
  );
}

export default TableAdapter;
